import { render, staticRenderFns } from "./ImportCustomers.vue?vue&type=template&id=6f17af47&"
import script from "./ImportCustomers.vue?vue&type=script&lang=js&"
export * from "./ImportCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ImportCustomers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports